'use client';

import { classNames } from "../../../utils/styles/classNames.js";
import { item } from "../MenuItem.css.js";
const getItemProps = ({ className, role }) => ({ className: classNames(className, item), role });
export {
  getItemProps
};
